import { Route, AppId, createPageRoute } from '@lumapps/router';

export const adminMobileNavigationRoute: Route = createPageRoute({
    slug: 'mobile/navigation',
    appId: AppId.backOffice,
});
